import type { RootState } from '../index'

export const selectAppLocale = (state: RootState) => state.locale.locale
